export const DATE_FORMATS = {
  EU: {
    value: "EU",
    label: "DD/MM/YYYY",
    pattern: "DD/MM/YYYY",
  },
  US: {
    value: "US",
    label: "MM/DD/YYYY",
    pattern: "MM/DD/YYYY",
  },
  ISO: {
    value: "ISO",
    label: "YYYY-MM-DD",
    pattern: "YYYY-MM-DD",
  },
  ASIAN: {
    value: "ASIAN",
    label: "YYYY.MM.DD",
    pattern: "YYYY.MM.DD",
  },
  SHORT: {
    value: "SHORT",
    labelKey: "common.dateFormat.short",
    pattern: "MMM D, YYYY",
  },
  LONG: {
    value: "LONG",
    labelKey: "common.dateFormat.long",
    pattern: "MMMM D, YYYY",
  },
};

export const TIME_FORMATS = {
  H24: {
    value: "H24",
    labelKey: "common.timeFormat.24hour",
    pattern: "HH:mm",
    patternWithSeconds: "HH:mm:ss",
  },
  H12: {
    value: "H12",
    labelKey: "common.timeFormat.12hour",
    pattern: "h:mm A",
    patternWithSeconds: "h:mm:ss A",
  },
};

export const DEFAULT_DATE_FORMAT = "EU";

export const DEFAULT_TIME_FORMAT = "H24";
